import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { DraftRedirectQuery } from './DraftRedirectQuery.graphql';
import type {
	DraftRedirectQuery as DraftRedirectQueryType,
	DraftRedirectQueryVariables,
} from './__types__/DraftRedirectQuery';

export const preloadDraftRedirect = ({
	contentId,
	draftShareId,
}: {
	contentId: string;
	draftShareId: string;
}) => {
	return query<DraftRedirectQueryType, DraftRedirectQueryVariables>({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: DraftRedirectQuery,
		variables: {
			contentId,
			draftShareId,
			status: ['draft'],
		},
	});
};
